import { z } from 'zod';

export const sellerPlatformSchema = z.enum(['Poizon']);

export type SellerPlatformSchema = z.infer<typeof sellerPlatformSchema>;
